<!-- vim: set filetype=html ts=2 sts=2 sw=2 expandtab: -->
<template>
  <div id="packlist">
    <nav class="navbar navbar-inverse navbar-fixed-top">
      <div class="container-fluid">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#responsive" aria-expanded="false">
            <span class="sr-only">Mobile Menu</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand fade-animation" href="https://xdcc.sumire.moe/">XDCC Packlist</a>
        </div>
        <div id="responsive" class="collapse navbar-collapse">
          <ul class="nav navbar-nav">
            <li><a class="fade-animation" href="https://sumire.moe">Home</a></li>
          </ul>
          <form id="search-form" class="navbar-form navbar-right" role="search">
            <div class="form-group" for="packlist-filter">
              <input type="search" id="packlist-filter" class="form-control packlist-filter" v-model.trim="currentFilter" placeholder="Filtered Search">
            </div>
          </form>
        </div>
      </div>
    </nav>
    <div id="main" class="container">
      <div id="content">
        <img class="header-img center-block" src="https://sumire.moe/wp-content/uploads/2017/10/nonoko-xdcc.png" />
        <div class="panel panel-default">
          <div class="panel-heading text-center">
            <h3 class="xdcc-header">Sumire|Nonoko XDCC Packlist</h3>
            <p><a class="xdcc-link fade-animation" href="irc://irc.rizon.net/Sumire">#Sumire@irc.rizon.net</a></p>
            <p class="text-center">Please use the <strong>Copy Query</strong> button to copy the XDCC command to your clipboard.</p>
          </div>
          <div class="table-responsive">
            <table id="packlist-data" class="table table-striped table-hover table-condensed">
              <thead>
                <tr>
                  <th id="pack-number" @click="sortKey = 'id'" class="text-center">Pack #
                    <span id="sort-default" class="sort-btn fa fa-sort" aria-hidden="true" v-if="sortKey !== 'id'"></span>
                    <span id="sort-asc" class="sort-btn fa fa-sort-numeric-asc" aria-hidden="true" v-if="sortKey === 'id' && direction == 1"></span>
                    <span id="sort-desc" class="sort-btn fa fa-sort-numeric-desc" aria-hidden="true" v-if="sortKey === 'id' && direction == -1"></span>
                  </th>
                  <th id="fetches" @click="sortKey = 'fetches'" class="text-center">
                    <span class="fa fa-download" aria-hidden="true"></span>
                    <span id="sort-default" class="sort-btn fa fa-sort" aria-hidden="true" v-if="sortKey !== 'fetches'"></span>
                    <span id="sort-asc" class="sort-btn fa fa-sort-numeric-asc" aria-hidden="true" v-if="sortKey === 'fetches' && direction == 1"></span>
                    <span id="sort-desc" class="sort-btn fa fa-sort-numeric-desc" aria-hidden="true" v-if="sortKey === 'fetches' && direction == -1"></span>
                  </th>
                  <th id="file-size" @click="sortKey = 'size'" class="text-center">
                    <span class="fa fa-hdd-o" aria-hidden="true"></span>
                    <span id="sort-default" class="sort-btn fa fa-sort" aria-hidden="true" v-if="sortKey !== 'size'"></span>
                    <span id="sort-asc" class="sort-btn fa fa-sort-numeric-asc" aria-hidden="true" v-if="sortKey === 'size' && direction == 1"></span>
                    <span id="sort-desc" class="sort-btn fa fa-sort-numeric-desc" aria-hidden="true" v-if="sortKey === 'size' && direction == -1"></span>
                  </th>
                  <th id="file-name" @click="sortKey = 'title'" class="text-left">
                    <span class="fa fa-file" aria-hidden="true"></span>
                    <span id="sort-default" class="sort-btn fa fa-sort" aria-hidden="true" v-if="sortKey !== 'title'"></span>
                    <span id="sort-asc" class="sort-btn fa fa-sort-alpha-asc" aria-hidden="true" v-if="sortKey === 'title' && direction == 1"></span>
                    <span id="sort-desc" class="sort-btn fa fa-sort-alpha-desc" aria-hidden="true" v-if="sortKey === 'title' && direction == -1"></span>
                  </th>
                  <th id="click-to-copy" class="text-center">
                    <span class="fa fa-files-o" aria-hidden="true"></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="fade-animation" v-for="pack in packlist">
                  <td class="text-center">{{ pack.id }}</td>
                  <td class="text-center">{{ pack.fetches }}</td>
                  <td class="text-center">{{ pack.size_text }}</td>
                  <td class="text-left">{{ pack.title }}</td>
                  <td class="text-center">
                    <button type="button" class="btn btn-primary" v-clipboard:copy="getXdccCommand(pack.id)" v-clipboard:success="onCopy" v-clipboard:error="onError">Copy Query
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <footer class="footer">
      <p class="text-center">{{ bandwidth }}</p>
      <p class="text-center">{{ stats }}</p>
      <p class="text-center">Developed by: <a class="xdcc-link fade-animation" href="https://sumire.moe/staff/#Ayanami">Ayanami</a> & <a class="xdcc-link fade-animation" href="https://sumire.moe/staff/#LastReaction">LastReaction</a></p>
    </footer>
  </div>
</template>

<script>
const HTTP_OK = 200;
const shared = [];

export default {
  name: 'packlist',
  props: ['src'],
  data() {
    return {
      currentFilter: '',
      direction: 1,
      currentSortKey: 'id',
      shared,
      dataLoaded: false,
    };
  },
  computed: {
    packs() {
      if(!this.dataLoaded) return [];
      if(!this._packs) {
        this._packs = this.shared.filter(p => p.src === this.src)[0].packs;
      }
      return this._packs;
    },
    packlist() {
      return this.sort(this.filter(this.packs));
    },
    sortKey: {
      get() {
        return this.currentSortKey;
      },
      set(key) {
        if(this.currentSortKey === key) this.direction *= -1;
        else this.direction = 1;
        this.currentSortKey = key;
      },
    },
    bandwidth() {
      if(!this.dataLoaded) return null;
      if(!this._bandwidth) {
        this._bandwidth = this.shared.filter(p => p.src === this.src)[0].bandwidth;
      }
      return `Bandwidth: current: ${this._bandwidth.current} record: ${this._bandwidth.record}`;
    },
    stats() {
      if(!this.dataLoaded) return null;
      if(!this._stats) {
        this._stats = this.shared.filter(p => p.src === this.src)[0].stats;
      }
      return `Total offered: ${this._stats.offered} Total transferred: ${this._stats.transferred}`;
    },
  },
  methods: {
    filter(data) {
      if(!this.currentFilter || !data) return data;
      return data.filter(
        x => x.title.toLowerCase()
              .indexOf(this.currentFilter.toLowerCase()) !== -1);
    },
    sort(data) {
      if(!data) return data;
      return data.sort((a, b) => {
        if(this.sortKey === 'title') {
          return this.direction * a[this.sortKey].localeCompare(
                b[this.sortKey],
                ['ja-JP', 'en'],
                { numeric: true },
              );
        }
        return this.direction * (a[this.sortKey] - b[this.sortKey]);
      });
    },
    getXdccCommand(packId) {
      return `/msg Sumire|Nonoko XDCC SEND ${packId}`;
    },
    onCopy(e) {
      this.$swal({
        title: 'Naisu!',
        html: `"${e.text}"<br/>has been copied to the clipboard.`,
        imageUrl: 'https://sumire.moe/wp-content/uploads/2017/05/ryuu-no-haisha-about.jpg',
        imageWidth: 400,
        imageHeight: 250,
        imageAlt: 'Nonoko is so proud of you!',
        timer: 5000,
      });
    },
    onError(e) {
      this.$swal({
        title: 'Yabai!',
        html: `"There seems to be an error.<br/>Try copying and pasting the text below:<br/>${e.text}`,
        imageUrl: 'https://sumire.moe/wp-content/uploads/2017/10/nonoko-xdcc-error.jpg',
        imageWidth: 400,
        imageHeight: 250,
        imageAlt: 'Holy shit what is happening, help me!',
      });
    },
  },
  created() {
    if(shared[this.src]) return;
    const xhr = new XMLHttpRequest();
    xhr.addEventListener('load', () => {
      if(xhr.status === HTTP_OK) {
        const list = JSON.parse(xhr.responseText);
        list.src = this.src;
        this.shared.push(list);
        this.dataLoaded = true;
      } else {
        // FIXME: display error somewhere
        console.error(`Error loading packlist: ${xhr.statusText}`);
      }
    });
    xhr.open('GET', this.src);
    xhr.send();
  },
};
</script>

<style lang="scss">
th {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// Packlist.vue?0e7cd293